import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/jackpotx_winner`;

class JackpotXWinnerServices {
  async getSessionList(activeGame, date_filter) {
    try {
      const action =
        API_ROUTE +
        `/get-session-list?game=${activeGame}&date_filter=${date_filter}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getSessionList:", error);
      throw error;
    }
  }

  async getJackpotXSessionList(filter) {
    try {
      const action =
        API_ROUTE +
        `/get-jackpotx-session-list?${filter}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getJackpotXSessionList:", error);
      throw error;
    }
  }

  async createJackpotXWinner(payload) {
    try {
      const action = API_ROUTE + `/save-jackpotx_winner-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in createJackpotXWinner:", error);
      throw error;
    }
  }

  async updateJackpotXWinner(payload) {
    try {
      const action = API_ROUTE + `/update-jackpotx_winner-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in updateJackpotXWinner:", error);
      throw error;
    }
  }
  async deleteJackpotXWinnerSession(session_id) {
    try {
      const action = API_ROUTE + `/delete-jackpotx_winner-data?session_id=${session_id}`;
      return await requestToken.del(action);
    } catch (error) {
      console.error("Error in deleteJackpotXWinnerSession:", error);
      throw error;
    }
  }
}

export default JackpotXWinnerServices;
